import { useParams } from 'react-router'
import styled from 'styled-components'
import { breakpoints } from '@/styles'
import UserChatRoom from '../chat-room'
import EmptyChatRoom from '../chat-room/empty-chat-room'
import SupportRoom from '../../../pages/Chat/chat-room/support-room'

const StyledEmptyChatRoom = styled(EmptyChatRoom)`
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding-bottom: 0;
  }
`

const ChatRoom = ({
  handleBack,
  sideBarHeader,
  chatFooterButton,
  emptyMessage,
  noTimelines,
  selectMode
}) => {
  const params = useParams()
  const timelineId = params.timelineId
  if (timelineId === 'support-room') {
    return <SupportRoom handleBack={handleBack} />
  }
  if (!timelineId || selectMode) {
    return (
      <StyledEmptyChatRoom
        handleBack={handleBack}
        message={emptyMessage}
        sideBarHeader={sideBarHeader}
        chatFooterButton={chatFooterButton}
        noTimelines={noTimelines}
      />
    )
  }

  return <UserChatRoom handleBack={handleBack} />
}

export default ChatRoom
